module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAAAXNSR0IArs4c6QAAAQRJREFUOBFjZEADEQu/Gv778y+OgZFBEyz1n+E6EwvTohXx3OeRlTIic8Lmf0r6/58xC1kMwgaKMjJMX5XINw8mxwRjhM/7agTR9P8Pw///U1g4eDxAGMQGqvn7/z9DJsg1MPUsMMb///9igc5jYPjPMGN1Mt8CmDiQXhA69xMDAyNjDtgLDAxgJ8NthPmJhZN3C5ImMBMuBvM3UBSu8T8DgwhI1fIoxjdg1UgETAymBiQF14ikjigm2RoZwxZ8sv7/j6Ea6Hsxoqxi+P+KkYmhlYk0TSCjGcVAeoBOJdYmZPcwipHtx1GNyAGJxqYkcP6/QjOMCO7/V0yg5APMhCRohiQ5AN0VT+haIDguAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/icon_team_private.png
// module id = ./src/_asset/sources/assets/images/icon_team_private.png
// module chunks = main